const getTableStyles = () => {
  return `.bulkbanklist-checkbox{
          width: 4%;
      }
      .bulkbanklist-lead-id{
          width: 6%;
      }
      .bulkbanklist-bank-payment{
        width: 9%;
      }
      .bulkbanklist-payment-date{
          width: 10%;
      }
      .bulkbanklist-bank{
          width: 6%;
      }
      .bulkbanklist-city{
          width: 8%;
      }
      .bulkbanklist-previous-payment{
          width: 10%;
      }
      .bulkbanklist-customer{
          width: 12%;
      }
      .bulkbanklist-car-regno{
          width: 8%;
      }
      .bulkbanklist-car-name{
          width: 12%;
      }
      .bulkbanklist-added-by{
          width: 10%;
      }
      .bulkbanklist-action{
          width: 10%;
      }
      `;
};

const getSortingClass = (sortingColumns, column) => {
  return sortingColumns[column] === 1
    ? "_asc"
    : sortingColumns[column] === -1
    ? "_desc"
    : "";
};
export { getTableStyles, getSortingClass };
